import './DownloadByClass.css';
import '../DownloadCards/DownloadCards.css';
import { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress, MenuItem, Checkbox, Chip, Radio, Typography, LinearProgress, Button } from '@mui/material';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSnackbar } from 'notistack';
import axios, { all } from 'axios';
import JSZip, { forEach } from 'jszip';
import { saveAs } from 'file-saver';
import domtoimage from "dom-to-image-chrome-fix-retina";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import StandardOutlinedTextfield from '../../components/StandardOutlinedTextfield/StandardOutlinedTextfield';
import DownloadIcon from '@mui/icons-material/Download';
import SchoolIcon from '@mui/icons-material/School';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { generateIdCardsPdf } from '../../utils/idCardPdfGenerator';
// Components
import StandardPageWrapper from '../../components/StandardPageWrapper/StandardPageWrapper';
import CustomMuiSelect from '../../components/CustomMuiSelect/CustomMuiSelect';
import StandardButton from '../../components/StandardButton/StandardButton';
import StandardPreviewCardDownload from '../../components/StandardPreviewCardDownload/StandardPreviewCardDownload';
// ICONs & SVGs
import SearchIcon from '@mui/icons-material/Search';

function DownloadByClass() {
  const { enqueueSnackbar } = useSnackbar();

  const [allIDCards, setAllIDCards] = useState([]);

  const [allBtnData, setAllBtnData] = useState({ school: '', class: '', is_verified: '' });
  // console.log(allBtnData);
  const [date, setDate] = useState('');
  const [allSchoolData, setAllSchoolData] = useState([]);
  const [allCLassData, setAllCLassData] = useState([]);

  const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);

  // ----------------------
  const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [downloadType, setDownloadType] = useState("all");
  const [openCountModal, setOpenCountModal] = useState(false);
  const [downloadFormat, setDownloadFormat] = useState('pdf'); // 'pdf' | 'zip'
  const [downloadProgress, setDownloadProgress] = useState({ current: 0, total: 0, text: '' });
  const [startCount, setStartCount] = useState({ oneSideFront: 1, bothSideFront: 1, bothSideBack: 1 });

  // const [allIDCards, setAllIDCards] = useState([]);
  const [allIDCardsStorage, setAllIDCardsStorage] = useState([]);
  const [allIDCardsCheckBox, setAllIDCardsCheckBox] = useState({});
  const [cardType, setCardType] = useState("all");

  // const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [downloadSelectedLoading, setDownloadSelectedLoading] = useState(false);


  // Detect school user role
  const userRole = sessionStorage.getItem('ID_CardAdmin_user_role');
  const isSchoolUser = userRole === 'school';
  let schoolUser = null;
  if (isSchoolUser) {
    try {
      schoolUser = JSON.parse(sessionStorage.getItem('ID_CardAdmin_user'));
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    if (isSchoolUser && schoolUser?.schoolid) {
      setAllBtnData(prev => ({ ...prev, school: schoolUser.schoolid }));
      setAllSchoolData([{ schoolid: schoolUser.schoolid, name: schoolUser.name }]);
      setAllSchoolDataLoading(false);
      fetchAllClass({ target: { value: schoolUser.schoolid } });
    } else {
      fetchAllSchools();
    }
  }, [])

  const updateIsDownloaded = async () => {
    const payload = {
      "class_id": [allBtnData.class],
      "school_id": [allBtnData.school]
    }
    await axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/user/update_is_downloaded`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          // setAllIDCards(res.data.data);
          // console.log('Updating is_downloaded...', allBtnData.class);
          // console.log('api res',res.data.data);
          // setAllUserData(res.data.data);
        } else {
          enqueueSnackbar("Error Updating is_downloaded, Try Again !!!", {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        return enqueueSnackbar("Something Went Wrong !!!", {
          variant: "error",
        });
      });
  };

  const fetchAllSchools = async () => {
    await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschoolfordropdown`)
      .then(res => {
        if (res.data.success) {
          setAllSchoolData(res.data.data)
        } else {
          enqueueSnackbar('Error Fetching Schools, Try Again !!!', { variant: 'error' })
        }
        setAllSchoolDataLoading(false);
      })
      .catch(err => {
        console.log(err);
        setAllSchoolDataLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const fetchAllClass = async (e) => {
    setAllBtnData({ ...allBtnData, school: e.target.value, class: '', is_verified: '' })
    setDate(null);
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`, { schoolid: e.target.value })
      .then(res => {
        if (res.data.success) {
          setAllCLassData(res.data.data)
        } else {
          enqueueSnackbar('Error Fetching Class, Try Again !!!', { variant: 'error' })
        }
      })
      .catch(err => {
        console.log(err);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }
  const fetchAsIsVerified = async (e) => {
    setAllBtnData({ ...allBtnData, is_verified: e.target.value })
  }

  const onSearchByClass = async () => {
    if (Object.values(allBtnData).includes('')) {
      return enqueueSnackbar('Please Select All The Values !!!', { variant: 'error' });
    }

    setSearchLoading(true);

    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/user/getmapped_data_byclassid`, {
        class_id: allBtnData.class,
      })
      .then(res => {
        if (res.data.success) {
          let formatedDate;

          if (date === null || date === '') {
            formatedDate = null;
          } else {
            formatedDate = date;
          }

          const originalData = res.data.data; // ✅ SAVE ORIGINAL DATA
          let updatedData = [];

          // ✅ VERIFIED = 1
          if (allBtnData.is_verified === '1') {
            for (let index = 0; index < originalData[0].user_data.length; index++) {
              const element = originalData[0].user_data[index];

              if (element.is_verified === 1) {
                if (formatedDate !== null) {
                  if (formatedDate === element.updated_at.slice(0, 10)) {
                    updatedData.push(element);
                  }
                } else {
                  updatedData.push(element);
                }
              }
            }
          }

          // ✅ VERIFIED = 0
          else if (allBtnData.is_verified === '0') {
            for (let index = 0; index < originalData[0].user_data.length; index++) {
              const element = originalData[0].user_data[index];

              if (element.is_verified === 0) {
                if (formatedDate !== null) {
                  if (formatedDate === element.updated_at.slice(0, 10)) {
                    updatedData.push(element);
                  }
                } else {
                  updatedData.push(element);
                }
              }
            }
          }

          // ✅ ALL VERIFIED
          else {
            for (let index = 0; index < originalData[0].user_data.length; index++) {
              const element = originalData[0].user_data[index];

              if (formatedDate !== null) {
                if (formatedDate === element.updated_at.slice(0, 10)) {
                  updatedData.push(element);
                }
              } else {
                updatedData.push(element);
              }
            }
          }

          // ✅ APPLY FILTERED DATA
          res.data.data[0].user_data = updatedData;

          // ✅ MAIN STATE
          setAllIDCards(res.data.data);

          // ✅ STORAGE STATE FOR DROPDOWN FILTER
          setAllIDCardsStorage(res.data.data);

          // ✅ CHECKBOX INITIALIZATION
          let checkboxObj = {};
          res.data.data?.[0]?.user_data?.forEach(user => {
            checkboxObj[`standardPreviewCard_selectID_${user?.mapped_id}`] = false;
          });
          setAllIDCardsCheckBox(checkboxObj);

          // ✅ RESET DROPDOWN
          setCardType('all');
        }
        else {
          setAllIDCards([]);
          setAllIDCardsStorage([]);
          setAllIDCardsCheckBox({});
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }

        setSearchLoading(false);
      })
      .catch(err => {
        console.log(err);
        setSearchLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
      });
  };

  const onCardTypeChange = (e) => {
    let idCardsArr = [];

    switch (e.target.value) {
      case 'all':
        idCardsArr = [...allIDCardsStorage?.[0]?.user_data];
        break;

      case 'downloaded':
        idCardsArr = allIDCardsStorage?.[0]?.user_data?.filter(
          c => c?.is_downloaded === 1
        );
        break;

      case 'not_downloaded':
        idCardsArr = allIDCardsStorage?.[0]?.user_data?.filter(
          c => c?.is_downloaded !== 1
        );
        break;

      default:
        idCardsArr = [...allIDCardsStorage?.[0]?.user_data];
        break;
    }

    let checkboxObj = {};
    idCardsArr?.forEach(user => {
      checkboxObj[`standardPreviewCard_selectID_${user?.mapped_id}`] = false;
    });

    setAllIDCardsCheckBox(checkboxObj);
    setCardType(e.target.value);
    setAllIDCards([{ ...allIDCardsStorage?.[0], user_data: idCardsArr }]);
  };



  const onDownloadCards = async (type = "all") => {
    const zip = new JSZip();
    setDownloadAllLoading(type === "all");
    setDownloadSelectedLoading(type === "selected");

    let downloadUsers = [];
    let unverifiedCount = 0;

    // ✅ SELECT MODE LOGIC
    if (type === "selected") {
      const filteredIds = [];

      Object.keys(allIDCardsCheckBox)?.forEach(key => {
        if (allIDCardsCheckBox[key]) {
          filteredIds.push(key.split("_")[2]);
        }
      });

      if (filteredIds.length === 0) {
        setDownloadSelectedLoading(false);
        return enqueueSnackbar("Please select at least one card!", { variant: "error" });
      }

      downloadUsers = allIDCards?.[0]?.user_data?.filter(user =>
        filteredIds.includes(String(user.mapped_id)) && user.is_verified === 1
      );

      unverifiedCount = filteredIds.length - downloadUsers.length;

      // ✅ 1. ALL UNVERIFIED → ERROR
      if (downloadUsers.length === 0) {
        setDownloadSelectedLoading(false);
        return enqueueSnackbar(
          "No verified cards selected for download!",
          { variant: "error" }
        );
      }

      // ✅ 2. SOME VERIFIED, SOME SKIPPED → WARNING
      if (downloadUsers.length > 0 && unverifiedCount > 0) {
        enqueueSnackbar(
          `${unverifiedCount} selected card(s) were unverified and skipped.`,
          { variant: "warning" }
        );
      }

      // ✅ 3. ALL VERIFIED → SUCCESS
      if (downloadUsers.length === filteredIds.length) {
        enqueueSnackbar(
          "All selected cards are verified.",
          { variant: "success" }
        );
      }

    }
    // ✅ ALL MODE LOGIC
    else {
      downloadUsers = allIDCards?.[0]?.user_data?.filter(
        user => user.is_verified === 1
      ) || [];

      unverifiedCount = allIDCards?.[0]?.user_data?.length - downloadUsers.length;

      // ✅ 1. ALL UNVERIFIED → ERROR
      if (downloadUsers.length === 0) {
        setDownloadSelectedLoading(false);
        return enqueueSnackbar(
          "No verified cards selected for download!",
          { variant: "error" }
        );
      }

      // ✅ 2. SOME VERIFIED, SOME SKIPPED → WARNING
      if (downloadUsers.length > 0 && unverifiedCount > 0) {
        enqueueSnackbar(
          `${unverifiedCount} selected card(s) were unverified and skipped.`,
          { variant: "warning" }
        );
      }

      // ✅ 3. ALL VERIFIED → SUCCESS
      if (downloadUsers.length === allIDCards?.[0]?.user_data?.length) {
        enqueueSnackbar(
          "All selected cards are verified.",
          { variant: "success" }
        );
      }


      if (downloadUsers.length === 0) {
        setDownloadAllLoading(false);
        return enqueueSnackbar("No verified cards available for download!", { variant: "error" });
      }
    }

    // 💳 CREDIT PRE-CHECK: Check credits if any cards are not yet downloaded
    const unDownloadedCards = downloadUsers.filter(u => u.is_downloaded !== 1);
    if (unDownloadedCards.length > 0) {
      try {
        const checkRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/check-download-credits`, {
          school_id: allBtnData.school,
          ids: downloadUsers.map(u => u.mapped_id)
        });
        if (!checkRes.data.success || !checkRes.data.can_download) {
          setDownloadAllLoading(false);
          setDownloadSelectedLoading(false);
          setOpenCountModal(false);
          return enqueueSnackbar(
            checkRes.data.message || 'Please recharge your account. Insufficient credits.',
            { variant: 'error' }
          );
        }
      } catch (err) {
        setDownloadAllLoading(false);
        setDownloadSelectedLoading(false);
        setOpenCountModal(false);
        return enqueueSnackbar(
          err.response?.data?.message || 'Error verifying school credits. Please try again.',
          { variant: 'error' }
        );
      }
    }

    const selectedSchoolName =
      allSchoolData?.filter(s => s.schoolid === allBtnData.school)?.[0]?.name || 'School';
    const cleanSchoolName = selectedSchoolName.replace(/[^a-zA-Z0-9_-]/g, '_');

    if (downloadFormat === 'pdf') {
      setDownloadProgress({ current: 0, total: downloadUsers.length, text: 'Preparing PDF generator...' });

      try {
        await generateIdCardsPdf(downloadUsers, {
          fileName: `${cleanSchoolName}_ID_Cards.pdf`,
          onProgress: (current, total, statusText) => {
            setDownloadProgress({ current, total, text: statusText });
          }
        });

        // ✅ UPDATE DOWNLOAD STATUS BASED ON TYPE
        if (type === "all") {
          await updateIsDownloaded(); // ✅ whole class update
        } else if (type === "selected") {
          const selectedIds = downloadUsers.map(u => u.mapped_id); // ✅ only selected cards
          await onSendDownloadedSchoolsToServer(selectedIds);
        }
      } catch (pdfErr) {
        console.error('Error generating PDF:', pdfErr);
        enqueueSnackbar('Failed to generate PDF. Please try again.', { variant: 'error' });
      } finally {
        setDownloadAllLoading(false);
        setDownloadSelectedLoading(false);
        setDownloadProgress({ current: 0, total: 0, text: '' });
        setOpenCountModal(false);
      }
      return;
    }

    // ✅ ZIP FORMAT
    var bothSideFrontCount;
    var bothSideBackCount;
    var oneSideCount;

    if (allIDCards[0]?.id_card?.type == 1) {
      const oneSide = zip.folder("one-side");
      oneSideCount = startCount.oneSideFront;

      for (let i = 0; i < downloadUsers.length; i++) {
        setDownloadProgress({ current: i + 1, total: downloadUsers.length, text: `Packaging card ${i + 1} of ${downloadUsers.length}...` });
        const frontNode = document.getElementById(
          `previewcustomCard-front-${downloadUsers[i]?.mapped_id}`
        );

        try {
          const dataUrl = await domtoimage.toPng(frontNode, { cacheBust: true });
          const b64data = dataUrl.split(",")[1];

          oneSide.file(`${oneSideCount}.png`, b64data, { base64: true });
          oneSideCount++;
        } catch (error) {
          console.error("Error Downloading Image!", error);
        }
      }
    }
    // ✅ BOTH SIDE CARDS
    else {
      const bothSideFront = zip.folder("both-side/front");
      const bothSideBack = zip.folder("both-side/back");

      bothSideFrontCount = startCount.bothSideFront;
      bothSideBackCount = startCount.bothSideBack;

      for (let i = 0; i < downloadUsers.length; i++) {
        setDownloadProgress({ current: i + 1, total: downloadUsers.length, text: `Packaging card ${i + 1} of ${downloadUsers.length}...` });
        const frontNode = document.getElementById(
          `previewcustomCard-front-${downloadUsers[i]?.mapped_id}`
        );
        const backNode = document.getElementById(
          `previewcustomCard-back-${downloadUsers[i]?.mapped_id}`
        );

        try {
          const frontImageDataUrl = await domtoimage.toPng(frontNode, { cacheBust: true });
          const backImageDataUrl = await domtoimage.toPng(backNode, { cacheBust: true });

          bothSideFront.file(
            `${bothSideFrontCount}.png`,
            frontImageDataUrl.split(",")[1],
            { base64: true }
          );

          bothSideBack.file(
            `${bothSideBackCount}.png`,
            backImageDataUrl.split(",")[1],
            { base64: true }
          );

          bothSideFrontCount++;
          bothSideBackCount++;
        } catch (error) {
          console.error("Error downloading image!", error);
        }
      }
    }

    setDownloadProgress({ current: downloadUsers.length, total: downloadUsers.length, text: 'Compressing ZIP archive...' });
    zip.generateAsync({ type: "blob" }).then(async (content) => {
      saveAs(content, `${selectedSchoolName} ID Cards.zip`);
      // ✅ UPDATE DOWNLOAD STATUS BASED ON TYPE
      if (type === "all") {
        await updateIsDownloaded(); // ✅ whole class update
      }
      else if (type === "selected") {
        const selectedIds = downloadUsers.map(u => u.mapped_id); // ✅ only selected cards
        await onSendDownloadedSchoolsToServer(selectedIds);
      }
      setDownloadAllLoading(false);
      setDownloadSelectedLoading(false);
      setDownloadProgress({ current: 0, total: 0, text: '' });
      setOpenCountModal(false);
    }).catch(err => {
      console.error(err);
      setDownloadAllLoading(false);
      setDownloadSelectedLoading(false);
      setDownloadProgress({ current: 0, total: 0, text: '' });
      setOpenCountModal(false);
    });
  };

  const onSendDownloadedSchoolsToServer = async (arr) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updatedownloadstatus`, { ids: arr });
      if (res.data.success) {
        if (res.data.debited_credits > 0) {
          enqueueSnackbar(`Download status updated. ${res.data.debited_credits} credit(s) debited.`, { variant: 'info' });
        }
      } else {
        enqueueSnackbar(res.data.message || 'Error Uploading Schools Array, Try Again !!!', { variant: 'error' });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar(err.response?.data?.message || 'Something Went Wrong !!!', { variant: 'error' });
    } finally {
      setDownloadSelectedLoading(false);
      setDownloadAllLoading(false);
    }
  };


  return (
    <StandardPageWrapper
      header="Download By Class"
      btns={
        <>
          {/* <CustomMuiSelect
            label="Select School"
            val={allBtnData.school}
            onChange={fetchAllClass}
            width={150}
            size="small"
            disabled={searchLoading}
          >
            {allSchoolData?.map((c, i) => (
              <MenuItem value={c?.schoolid} key={i}>
                {c?.name}
              </MenuItem>
            ))}
          </CustomMuiSelect> */}

          {/* <Autocomplete
            options={allSchoolData || []}
            getOptionLabel={(option) => option?.name || ""}
            value={allSchoolData.find((school) => school.schoolid === allBtnData.school) || null}
            onChange={(event, newValue) => setAllBtnData({ ...allBtnData, school: newValue?.schoolid || "" })}
            onChange={fetchAllClass}
            disabled={searchLoading}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select School"
                size="small"
                sx={{
                  width: 150,
                  backgroundColor: "white", // Setting the background color to white
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'lightgray', // Optional: Adjust border color
                    },
                    '&:hover fieldset': {
                      borderColor: 'gray', // Optional: Change border color on hover
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'darkgreen', // Optional: Focus border color
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: 'black', // Default label color (before hover/focus)
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: 'black', // Label color when focused
                  },
                  '& .MuiInputLabel-root:hover': {
                    color: 'black', // Label color when hovered
                  },
                }}
                // style={{ width: 150 }}
                disabled={searchLoading}
              />
            )}
          /> */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            gap: "20px",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "15px", width: "100%" }}>
              {isSchoolUser ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Chip
                    icon={<SchoolIcon />}
                    label={schoolUser?.name || "My School"}
                    sx={{
                      fontWeight: 700,
                      fontSize: "14px",
                      backgroundColor: "#e0e7ff",
                      color: "#3730a3",
                      padding: "4px 8px"
                    }}
                  />
                </div>
              ) : (
                <Autocomplete
                  options={allSchoolData}
                  getOptionLabel={(option) => option.name || ""}
                  value={allSchoolData.find(school => school.schoolid === allBtnData.school) || null}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      fetchAllClass({ target: { value: newValue.schoolid } });
                    } else {
                      setAllBtnData({ ...allBtnData, school: '', class: '', is_verified: '' });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select School"
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{
                        width: 150,
                        backgroundColor: "white", // Setting the background color to white
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'lightgray', // Optional: Adjust border color
                          },
                          '&:hover fieldset': {
                            borderColor: 'gray', // Optional: Change border color on hover
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: 'darkgreen', // Optional: Focus border color
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'black', // Default label color (before hover/focus)
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: 'black', // Label color when focused
                        },
                        '& .MuiInputLabel-root:hover': {
                          color: 'black', // Label color when hovered
                        },
                      }}
                      disabled={searchLoading}
                    />
                  )}
                  loading={allSchoolDataLoading}
                  disabled={searchLoading}
                />
              )}
              <CustomMuiSelect
                label="Select Class"
                val={allBtnData.class}
                onChange={(e) =>
                  setAllBtnData({ ...allBtnData, class: e.target.value })
                }
                width={150}
                size="small"
                sx={{ marginRight: 1.5 }}
                disabled={searchLoading}
              >
                {allCLassData?.map((c, i) => (
                  <MenuItem
                    value={c?.classid}
                    key={i}
                  >{`${c?.standard} - ${c?.division}`}</MenuItem>
                ))}
              </CustomMuiSelect>
              <CustomMuiSelect
                label="Is Verified"
                val={allBtnData.is_verified}
                onChange={fetchAsIsVerified}
                // onChange={(e) =>
                // setAllBtnData({ ...allBtnData, is_verified: e.target.value })
                // }
                width={150}
                size="small"
                sx={{ marginRight: 1.5 }}
                disabled={searchLoading}
              >
                <MenuItem
                  value="all"
                  key="2"
                >All</MenuItem>
                <MenuItem
                  value="1"
                  key="1"
                >Verified</MenuItem>
                <MenuItem
                  value="0"
                  key="0"
                >Not Verified</MenuItem>
              </CustomMuiSelect>
              <input
                type="date"
                style={{ marginRight: 15 }}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              // onChange={(newDate) => setDate(newDate)}
              />
              {/* <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ marginRight: 1.5 }}>
            <DemoContainer components={['DatePicker']}>
              <DemoItem>
                <DatePicker
                  label="Verified On"
                  value={date}
                  onChange={(newDate) => setDate(newDate)}
                  className="customLabel"
                  classes={{ label: 'customLabel' }}
                  sx={{
                    marginRight: 1.5,
                    backgroundColor: "white",
                    width: "160px"
                  }}
                />
              </DemoItem>
            </DemoContainer>
          </LocalizationProvider> */}
              <StandardButton
                color="white"
                variant="contained"
                style={{ background: "darkgreen !important" }}
                onClick={onSearchByClass}
                label={<SearchIcon />}
                loading={searchLoading}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%" }}>
              {allIDCards?.length > 0 && (
                <>
                  {/* <StandardButton
                                variant="contained"
                                onClick={onDownloadNotDownloaded}
                                loading={downloadNotDownloadedLoading}
                                style={{ background: "#032025 !important" }}
                                label="Not Downloaded"
                            /> */}
                  <CustomMuiSelect label="Select Card Type" val={cardType} onChange={onCardTypeChange}
                    width={140} size="small" disabled={searchLoading}
                  >
                    <MenuItem value='all'>All</MenuItem>
                    <MenuItem value='downloaded'>Downloaded</MenuItem>
                    <MenuItem value='not_downloaded'>Not Downloaded</MenuItem>
                  </CustomMuiSelect>


                  <StandardButton
                    variant="contained"
                    onClick={() => {
                      setDownloadType("selected");
                      setOpenCountModal(true);
                    }}
                    loading={downloadSelectedLoading}
                    style={{ background: "#0d7a8e !important" }}
                    label="Download Selected"
                  />

                  <StandardButton
                    variant="contained"
                    onClick={() => {
                      setDownloadType("all");
                      setOpenCountModal(true);
                    }}
                    loading={downloadAllLoading}
                    style={{ background: "darkgreen !important", size: "small" }}
                    label="Download All"
                    startIcon={<DownloadIcon />}
                  />
                </>
              )}
            </div>
          </div>
        </>
      }
    >
      <div id="preview">
        <div className="previewCard_cont">
          {searchLoading ? (
            <CircularProgress
              size={30}
              sx={{ display: "block", margin: "auto", color: "#4b49ac" }}
            />
          ) : (
            <>
              {allIDCards?.[0]?.user_data?.map((u, i) => (
                <div key={u?.mapped_id} className="standardPreviewCard_parent">

                  {/* ✅ CHECKBOX ADDED HERE */}
                  <Checkbox
                    checked={
                      allIDCardsCheckBox[`standardPreviewCard_selectID_${u.mapped_id}`]
                    }
                    onChange={(e) =>
                      setAllIDCardsCheckBox({
                        ...allIDCardsCheckBox,
                        [`standardPreviewCard_selectID_${u.mapped_id}`]: e.target.checked,
                      })
                    }
                  />

                  {/* ✅ YOUR EXISTING CARD */}
                  <StandardPreviewCardDownload
                    custom_uid={u?.mapped_id}
                    cardData={allIDCards?.[0]?.id_card}
                    userData={u}
                  />

                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <Dialog
        open={openCountModal}
        onClose={() => { if (!downloadAllLoading && !downloadSelectedLoading) setOpenCountModal(false); }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ padding: '20px 24px 12px 24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <span style={{ fontWeight: 700, fontSize: '18px', color: '#111827' }}>
              Download ID Cards
            </span>
            <Chip
              size="small"
              label={downloadType === 'selected' ? 'Selected Cards' : 'All Cards in Class'}
              sx={{ fontWeight: 600, backgroundColor: '#e0e7ff', color: '#3730a3' }}
            />
          </div>
        </DialogTitle>
        <DialogContent sx={{ padding: '12px 24px 20px 24px' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#374151', marginBottom: '8px' }}>
            Select Download Format:
          </Typography>

          {/* Format Grid: PDF vs ZIP */}
          <div className="downloadCards_formatGrid">
            {/* Option 1: PDF Sheet */}
            <div
              className={`downloadCards_formatCard ${downloadFormat === 'pdf' ? 'downloadCards_formatCard_active' : ''}`}
              onClick={() => !(downloadAllLoading || downloadSelectedLoading) && setDownloadFormat('pdf')}
            >
              <div className="downloadCards_formatHeader">
                <div className="downloadCards_formatTitle">
                  <PictureAsPdfIcon sx={{ color: '#ef4444' }} />
                  <span>PDF Sheet (Print-Ready)</span>
                </div>
                <Radio
                  checked={downloadFormat === 'pdf'}
                  onChange={() => setDownloadFormat('pdf')}
                  disabled={downloadAllLoading || downloadSelectedLoading}
                  size="small"
                  sx={{ padding: 0 }}
                />
              </div>
              <div className="downloadCards_formatDesc">
                Standard <strong>21 CM × 14.85 CM</strong> landscape sheet with side-by-side cards.
              </div>
              <span className="downloadCards_formatTag">Recommended</span>
            </div>

            {/* Option 2: ZIP Archive */}
            <div
              className={`downloadCards_formatCard ${downloadFormat === 'zip' ? 'downloadCards_formatCard_active' : ''}`}
              onClick={() => !(downloadAllLoading || downloadSelectedLoading) && setDownloadFormat('zip')}
            >
              <div className="downloadCards_formatHeader">
                <div className="downloadCards_formatTitle">
                  <FolderZipIcon sx={{ color: '#f59e0b' }} />
                  <span>ZIP Archive (Images)</span>
                </div>
                <Radio
                  checked={downloadFormat === 'zip'}
                  onChange={() => setDownloadFormat('zip')}
                  disabled={downloadAllLoading || downloadSelectedLoading}
                  size="small"
                  sx={{ padding: 0 }}
                />
              </div>
              <div className="downloadCards_formatDesc">
                Individual PNG card images organized into front & back folders with serial numbering.
              </div>
              <span className="downloadCards_formatTag" style={{ background: '#fef3c7', color: '#92400e' }}>
                ZIP / PNG
              </span>
            </div>
          </div>

          {/* Detailed Format Configuration */}
          {downloadFormat === 'pdf' ? (
            <div className="downloadCards_pdfInfoBox">
              <div className="downloadCards_pdfInfoTitle">
                <CheckCircleOutlineIcon fontSize="small" />
                <span>PDF Layout Specification:</span>
              </div>
              <ul className="downloadCards_pdfInfoList">
                <li><strong>Sheet Size:</strong> 21.0 CM (Width) × 14.85 CM (Height) - Landscape</li>
                <li><strong>Card Size:</strong> 5.5 CM (Width) × 8.7 CM (Height)</li>
                <li><strong>Arrangement:</strong> Side-by-side with <strong>Back side on the Left</strong> and <strong>Front side on the Right</strong></li>
                <li><strong>Multi-Card Compilation:</strong> All cards compiled page-by-page (1 card per page) into a single PDF.</li>
              </ul>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginTop: 12 }}>
              <Typography variant="caption" sx={{ color: '#6b7280' }}>
                Customize starting serial numbers for image filenames inside the ZIP archive:
              </Typography>
              <StandardOutlinedTextfield
                label="One Side Start Count"
                name="oneSideFront"
                val={startCount?.oneSideFront}
                setVal={setStartCount}
                spreadData={startCount}
                default={1}
              />
              <StandardOutlinedTextfield
                label="Both Side Start Front Count"
                name="bothSideFront"
                val={startCount?.bothSideFront}
                setVal={setStartCount}
                spreadData={startCount}
              />
              <StandardOutlinedTextfield
                label="Both Side Back Front Count"
                name="bothSideBack"
                val={startCount?.bothSideBack}
                setVal={setStartCount}
                spreadData={startCount}
              />
            </div>
          )}

          {/* Progress Bar */}
          {(downloadAllLoading || downloadSelectedLoading) && (
            <div className="downloadCards_progressCont">
              <Typography variant="body2" sx={{ fontWeight: 600, color: '#1e40af', marginBottom: '8px' }}>
                {downloadProgress.text || 'Processing...'}
              </Typography>
              <LinearProgress
                variant={downloadProgress.total > 0 ? "determinate" : "indeterminate"}
                value={downloadProgress.total > 0 ? (downloadProgress.current / downloadProgress.total) * 100 : 0}
                sx={{ height: 8, borderRadius: 4 }}
              />
              {downloadProgress.total > 0 && (
                <Typography variant="caption" sx={{ color: '#6b7280', marginTop: '6px', display: 'block' }}>
                  {downloadProgress.current} / {downloadProgress.total} completed ({Math.round((downloadProgress.current / downloadProgress.total) * 100)}%)
                </Typography>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '12px 24px 20px 24px' }}>
          <Button
            onClick={() => setOpenCountModal(false)}
            disabled={downloadAllLoading || downloadSelectedLoading}
            sx={{ textTransform: 'none', color: '#6b7280' }}
          >
            Cancel
          </Button>
          <StandardButton
            variant="contained"
            label={(downloadAllLoading || downloadSelectedLoading) ? 'Generating...' : (downloadFormat === 'pdf' ? 'Download PDF' : 'Download ZIP')}
            startIcon={downloadFormat === 'pdf' ? <PictureAsPdfIcon /> : <FolderZipIcon />}
            onClick={() => onDownloadCards(downloadType)}
            loading={downloadType === "all" ? downloadAllLoading : downloadSelectedLoading}
            style={{
              background: downloadFormat === 'pdf' ? '#dc2626 !important' : '#2563eb !important',
              color: '#ffffff'
            }}
          />
        </DialogActions>
      </Dialog>
    </StandardPageWrapper>
  );
}

export default DownloadByClass
